<template>
  <filter-bar>
    <div class="md-layout-item md-layout md-medium-size-25 md-small-size-25 md-xsmall-size-100">
      <md-field>
        <label>Familia</label>
        <md-select v-model="payload.family" @change="selectedFamily">
          <md-option :value="0">Todas</md-option>
          <md-option v-for="family in families" :key="family.id" :value="family.id">{{family.name}}</md-option>
        </md-select>
      </md-field>
    </div>

    <div class="md-layout-item md-layout md-medium-size-25 md-small-size-25 md-xsmall-size-100">
      <md-field>
        <label>Subfamilia</label>
        <md-select v-model="payload.subfamily" :disabled="!payload.family">
          <md-option :value="0">Todas</md-option>
          <md-option
            v-for="subfamily in familySubfamilies"
            :key="subfamily.id"
            :value="subfamily.id"
          >{{subfamily.name}}</md-option>
        </md-select>
      </md-field>
    </div>

    <div class="md-layout-item md-layout md-medium-size-25 md-small-size-25 md-xsmall-size-100">
      <md-field>
        <label>Aprobación de ARe</label>
        <md-select v-model="payload.areValidation">
          <md-option :value="2">Todos</md-option>
          <md-option :value="1">Aprobados</md-option>
          <md-option :value="0">Sin aprobar</md-option>
        </md-select>
      </md-field>
    </div>

    <div class="md-layout-item md-layout md-medium-size-25 md-small-size-25 md-xsmall-size-100">
      <md-field>
        <label>Aprobación de Compras</label>
        <md-select v-model="payload.areValidation">
          <md-option :value="2">Todos</md-option>
          <md-option :value="1">Aprobados</md-option>
          <md-option :value="0">Sin aprobar</md-option>
        </md-select>
      </md-field>
    </div>
  </filter-bar>
</template>

<script>
import { Slider, Collapse } from "@/components";
import FilterBar from "@/components/FilterBar";
import catalogService from "@/services/catalog";
import { cloneDeep } from "lodash";

export default {
  components: {
    Slider,
    Collapse,
    FilterBar,
  },
  data() {
    // const { dateFrom, dateTo } = this.defaults;

    return {
      // dateFrom: moment().subtract(15, "days").format("YYYY-MM-DD")
      // dateTo: moment().subtract(15, "days").format("YYYY-MM-DD"),
      // highways: [],
      // jobTypes: [],
      // selectedHighway: null,
      families: [],
      subfamilies: [],
      // selectedFamily: 0,
      // selectedSubfamily: 0,
      // areValidation: 2,
      // purchaseValidation: 2,
      payload: {},
    };
  },
  mounted() {
    this.payload = cloneDeep(this.value);
    Promise.all([
      catalogService.fetch("services/families"),
      catalogService.fetch("services/subfamilies"),
    ])
      .then(([families, subfamilies]) => {
        this.families = families;
        this.subfamilies = subfamilies;
      })
      .catch(this.$fireErrorResponse);
  },
  props: {
    // source: {
    //   type: Array,
    //   default: () => [],
    // },
    // dummyFilter: {
    //   type: Boolean,
    //   default: false,
    // },
    // filterSinisterType: {
    //   type: Boolean,
    //   default: true,
    // },
    // defaults: {
    //   type: Object,
    //   default: () => ({}),
    // },
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    selectedFamily() {
      this.payload.subfamily = 0;
    },
  },
  watch: {
    payload: {
      deep: true,
      handler(newVal) {
        this.$emit("input", newVal);
      },
    },
    // filteredData() {
    //   this.$emit("filtered", this.filteredData);
    // },
    // dateFrom(value) {
    //   this.$emit("updateDateFrom", value || null);
    // },
    // dateTo(value) {
    //   this.$emit("updateDateTo", value || null);
    // },
    // selectedHighway(value) {
    //   this.$emit("updateSelectedHighway", value || null);
    // },
    // selectedFamily(value) {
    //   this.$emit("updateSelectedFamily", value || null);
    //   this.selectedSubfamily = 0;
    // },
    // selectedSubfamily(value) {
    //   this.$emit("updateSelectedSubfamily", value || null);
    // },
    // areValidation(value) {
    //   this.$emit("updateAreValidation", validation_values[value]);
    // },
    // purchaseValidation(value) {
    //   this.$emit("updatePurchaseValidation", validation_values[value]);
    // },
  },
  computed: {
    // filteredData: function () {
    //   if (this.dummyFilter) {
    //     return this.source;
    //   }

    //   let dFrom = this.dateFrom;
    //   let dTo = this.dateTo;

    //   dFrom = dFrom && moment(dFrom);
    //   dTo = dTo && moment(dTo);
    //   const hi = this.selectedHighway;
    //   const job = this.selectedFamily;
    //   let filteredSource = this.source;

    //   if (dFrom) {
    //     filteredSource = filteredSource.filter((rS) =>
    //       rS.dateAssignment.isSameOrAfter(dFrom, "day")
    //     );
    //   }

    //   if (dTo) {
    //     filteredSource = filteredSource.filter((rS) =>
    //       rS.dateAssignment.isSameOrBefore(dTo, "day")
    //     );
    //   }

    //   if (hi) {
    //     filteredSource = filteredSource.filter((rS) => rS.highway == hi);
    //   }
    //   if (job) {
    //     filteredSource = filteredSource.filter((rS) => rS.job == job);
    //   }

    //   return filteredSource;
    // },

    familySubfamilies() {
      const { family } = this.payload;
      return family
        ? this.subfamilies.filter((sF) => sF.family === family)
        : [];
    },
  },
};
</script>

<style lang="scss" scoped>
.md-card-content:last-of-type {
  padding-bottom: 0px;
}

.md-card .md-card-content {
  padding: 0px 15px;
  line-height: 1.75em;
  position: relative;
}

.md-field.md-focused label,
.md-field.md-has-value label,
.md-field.md-focused.md-has-value label {
  color: #6d6d6dab !important;
  font-weight: bold;
  font-size: 1.4rem;
}

.md-field.md-focused label,
.md-field.md-field.md-has-value label {
  top: -1rem;
}

.vdatetime {
  margin-left: 2em;
  margin-top: 1.1em;
  width: 100%;
}

.date-label {
  top: -9px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Catalogs/Supplies/Validation/Filter.vue